import React from 'react';
import {useSelector} from "react-redux";
import {
    bbDoesUserHaveAccessToBreachRiskLevelForEntity,
    bbFindEntityWithinPortfolioOrSelf,
    bbSortIpCompare,
    mapObject, mapObjectAndReturnArrayOfObjects
} from "../../../util/bbHelpers";
import PropTypes from "prop-types";
import InfoSharpIcon from "@material-ui/icons/InfoSharp";
import {BRCustomizedTooltip as Tooltip} from "../accents/BRCustomizedTooltip";
import BBDataTable from "../tables/BBDataTable";
import {renderCellExpand} from "../tables/DataGridRenderCellExpand";
import {Chip} from "@material-ui/core";
import {Badge} from "reactstrap";

const TableContainer = ({portfolioView = false, cycleId=null,}) => {

    const {customers, customerInView} = useSelector(({customer}) => customer);
    const {entityInView, portfolios, loadingPortfolios, loadingPortfoliosError, loadingCycles, loadingCyclesError, loadingCycleDetails, loadingCycleDetailsError} = useSelector(({breachrisk}) => breachrisk);

    const {authUser} = useSelector(({auth}) => auth);

    const customerIdToUse = customers ? customerInView ? customerInView : null : null;
    const customer = customers ? customers[customerIdToUse] : null;
    const myEntity = bbFindEntityWithinPortfolioOrSelf(entityInView, portfolios, customerIdToUse);

    const isTrustedAgentForThisEntity = bbDoesUserHaveAccessToBreachRiskLevelForEntity(authUser, "infoLevel3", entityInView);

    const lastCycle = myEntity
    && myEntity.cycles
    && myEntity.settings
    && myEntity.settings.last_cycle_id
        ? myEntity.cycles[myEntity.settings.last_cycle_id] : null;

    const pastReportView = cycleId && lastCycle && cycleId !== lastCycle.id;

    const cycleInView = pastReportView
    && myEntity
    && myEntity.cycles
    && myEntity.cycles[cycleId]
        ? myEntity.cycles[cycleId]
        : lastCycle;

    const techData = myEntity
    && (lastCycle || cycleInView)
        ? cycleInView.techData
        : null;
    // console.log("techData from lastCycle", lastCycle, techData);
    
    const activeServices = techData
    && techData.totals
        ? techData.totals.active_services_detail
        : null;

    const totalNumRecords = techData
        && techData.meta
            ? techData.meta.services_to_send
            : null;

    // console.log("last cycle ", lastCycle, "threatVectors", threatVectors, "totalNumThreatVectors", totalNumThreatVectors);

    // console.log("active services", activeServices)
  /**************************/
  /*End Setup State and Dispatch*/
  /**************************/

    const title = <div className={"tourStepBRReportVectorsTable"}>
        Active Services Detected <Tooltip title={"Active Services include all services that are currently active."}>
            <InfoSharpIcon style={{fontSize: "smaller"}} className={``}/>
        </Tooltip>
    </div>;

    const description = <>Active services are processes that appear to running on the active hosts we've detected. These services are publicly accessible, and attackers can interact with them. Typically, you should ensure that the only services that appear in this list are those that you expect attackers to be able to survey and possibly attack.</>

  const userTableHeadings = [
      // { field: 'customerId', headerName: 'CID', hide: true, flex : 1, sortable: true, type: 'string', },
      { field: 'id', headerName: 'ID', hide: true, flex : 1, sortable: true, type: 'string', renderCell: (params) => {

              return params.value}},

      { field: 'ip', headerName: 'IP', hide: false, sortable: true, type: 'string', flex : .5,
          renderCell: (params)=>
              renderCellExpand(params, (<Tooltip title={``}>

                          <code>
                              {params.value}
                          </code>

                  </Tooltip>

              )),
          sortComparator: (v1, v2, param1, param2) => {
              try{
                  // console.log("IP column sort params", param1, param2);
                  return bbSortIpCompare(param1.value, param2.value);
              } catch(e) {
                  console.warn(e);
                  return false;
              }
          }},

      { field: 'name', headerName: 'Service', hide: false, sortable: true, type: 'string',  width: 150, renderCell: (params) =>
              renderCellExpand(params, (<Tooltip title={``}>
                          <span>
                              {params.value}
                          </span>
                  </Tooltip>

              ))},
      { field: 'port', headerName: 'Port', hide: false, sortable: true, type: 'string', width: 100, renderCell: (params) =>
              renderCellExpand(params, (<Tooltip title={``}>
                          <span>
                              <code>{params.value}</code>
                          </span>
                  </Tooltip>

              ))},
      { field: 'version', headerName: 'Version', hide: false, sortable: true, type: 'string', flex: 0.5, renderCell: (params) =>
              renderCellExpand(params, (<Tooltip title={``}>
                          <span>
                             {params.value}
                          </span>
                  </Tooltip>

              ))},

      { field: 'subdomains', headerName: 'Subdomains', hide: false, sortable: true, type: 'string', flex : 1,
          renderCell: (params)=>
              renderCellExpand(params, (<Tooltip title={``}>

                          <code>
                              {params.value}
                          </code>

                  </Tooltip>

              )),
          sortComparator: (v1, v2, param1, param2) => {
              try{
                  // console.log("IP column sort params", param1, param2);
                  return bbSortIpCompare(param1.value, param2.value);
              } catch(e) {
                  console.warn(e);
                  return false;
              }
          }},
      { field: 'isActive', headerName: 'Active', hide: false, sortable: true, type: 'boolean', width: 85,
          renderHeader: (params) =>
              renderCellExpand(params,
                  <span>
                      Active
                  </span>),
          renderCell: (params) =>
              renderCellExpand(params, (<>
                      {params.value
                          ? <Tooltip title={`Service is Active`}>
                                  <span>
                                      <Badge color={"primary"}>Active</Badge>
                                  </span>
                          </Tooltip>
                          : <Tooltip title={`This service is not active`}>
                                  <span>
                                      <Badge color={"secondary"}>Inactive</Badge>
                                  </span>
                          </Tooltip>
                      }
                  </>

              ))},
      { field: 'risk', headerName: 'Risk Level', hide: false, sortable: true, type: 'string',  width: 140, renderCell: (params) =>
              renderCellExpand(params, (<Tooltip title={``}>
                          <span>
                             <Chip
                                 label={params.value}
                                 // avatar={names.avatar}
                                 color={params.row.isHighRisk ? "primary" : "default"}
                                 // className={params.row.statusId === 1 || params.row.wasRowJustAdded ? "btn-floating pulse pulse-single" : ""}
                                 // onClick={!isTimelineButtonDisabled ? () => onClickToAttackTimeline(params.row.id) : null}
                             />
                          </span>
                  </Tooltip>

              ))},


  ];

    //peel the state data into a form the dataTable can read
  const tableData = activeServices && Array.isArray(activeServices) ? activeServices.map((object) => {

      return (
        {
            customerId: customer.CustomerId,
            id: object.id,
            idShort: object.id.slice(0, 6),
            port: object.port,
            name: object.service,
            isActive: object.is_active,
            isHighRisk: object.is_high_risk,
            risk: object.is_high_risk ? "High Risk" : "Routine Risk",
            isVerified: object.verified,
            version: object.version,
            details: object.details,
            cpe: object.cpe,
            ip: object.target_ip,
            subdomains: object.target_subdomains,

        }
    )
  }) : null;

  // console.log(tableData)
    // const tableDataAsArray = () => {
    //     console.log("Creating table data as array from services ", activeServices, "tableData", tableData);
    //     let arr=[];
    //     for (let ob in tableData) {
    //         // console.log("ob is ", tableData[ob])
    //         arr.push(tableData[ob]);
    //     }
    //     // console.log("resulting array ", arr);
    //     return arr;
    // }


    return (
        <div >
            {(((activeServices && Array.isArray(activeServices)) || totalNumRecords === 0)
                // && myEntity
                // && myEntity.settings
                // && customerIdToUse
                // && !loadingPortfoliosError[customerIdToUse]
                // && !loadingPortfolios[customerIdToUse]
                // && !loadingCycles[myEntity.settings.last_cycle_id]
                // && !loadingCyclesError[myEntity.settings.last_cycle_id]
                // && !loadingCycleDetails[myEntity.settings.last_cycle_id]
                // && !loadingCycleDetailsError[myEntity.settings.last_cycle_id]
            ) ?
            <BBDataTable
                subscriptionNameOrId={portfolioView ? "BRP" : "BRfB"}
                columns={userTableHeadings}
                rows={tableData}
                totalRows={totalNumRecords}
                progressValue={totalNumRecords === 0 ? 100 : activeServices.length / totalNumRecords * 100}
                bufferValue={totalNumRecords === 0 ? 100 : activeServices.length / totalNumRecords * 100 + 10}
                title={title}
                description={description}
                enableExport
                loading={false}
                // requiresModule={"monitor"}
                requiresBRLevel = {"infoLevel3"}
                authUser = {authUser}
                entityId = {entityInView}
                customer={customer}
                // topRightElement={<BBModuleIcon includeTooltip module={bbGetModulePropertyFromIdOrName("monitor", "id")} isActive={bbDoesCustomerHaveAccessToModule(customer, "monitor")} iconSize={"40px"}/>}
                defaultSortModel = {[
                    {
                        field: 'name',
                        sort: 'asc',
                    },

                ]}
                rowsPerPageOptions = {[10, 25, 50, 100]}
                defaultPageSize = {10}
                lite={!portfolioView}
                // portfolioStarter={!isTrustedAgentForThisEntity}
                portfolioView={portfolioView}
                elementDisplayNameForConsoleLogs={`BRservicesTechnicalTable`}

            />
            :
            <BBDataTable
                subscriptionNameOrId={portfolioView ? "BRP" : "BRfB"}
                columns={userTableHeadings}
                rows={[]}
                title={title}
                description={description}
                loading = {true}
                progressValue={0}
                bufferValue={15}
                rowsPerPageOptions = {[10, 25, 50, 100]}
                defaultPageSize = {10}
                lite={!portfolioView}
                // portfolioStarter={!isTrustedAgentForThisEntity}
                portfolioView={portfolioView}
            />
            }
        </div>
    );



}
TableContainer.propTypes = {
    customerId: PropTypes.string,
};

export default TableContainer